module.exports = __webpack_public_path__ + "static/media/Douro.88a8133b.svg";